const SORTING_DROPDOWN_CLASSES_PREFIX = "sorting-dropdown";

export const SORTING_DROPDOWN_CLASSES = {
  label: `${SORTING_DROPDOWN_CLASSES_PREFIX}-label`,
  select: `${SORTING_DROPDOWN_CLASSES_PREFIX}-select`,
  paper: `${SORTING_DROPDOWN_CLASSES_PREFIX}-paper`,
};

export const SORTING_DROPDOWN = {
  paperWidth: 260,
};
